import React, { useEffect, useState } from "react";
import Menu from "./Menu";
import SidebarData from "./Sidebar.data";
import "./sidebar.css";
import { NumberFormat as numberUtils } from "../../utilities/NumberFormat";
import AuthService from "../../services/Auth.service";
import { useHistory } from "react-router-dom";
import { checkPermission } from "../../utilities/hasPermission";
import { PanelLeftClose, PanelLeft } from "lucide-react";

function Sidebar({ setOpen, sidebarToggle, toggle }) {
  const [user, setUser] = useState(null);
  const [authed, setAuthed] = useState(false);

  const history = useHistory();

  useEffect(() => {
    setAuthed(AuthService.isAuthenticated());
    setUser(AuthService.getCurrentUser());
  }, []);

  const logout = () => {
    AuthService.logout();
    history.push("/");
    numberUtils.tabTitle("Login");
  };

  const username = user?.name || "Guest";
  const accessRole = (user?.access || "").toLowerCase();

  if (!authed) return null;

  return (
    <aside
      className={`main-sidebar ${
        sidebarToggle ? "sidebar-collapsed closeSidebar" : "sidebar-expanded opensidebar"
      }`}
    >
      {/* Logo fixed at top */}
      <div className="sidebar-logo-container">
        {!sidebarToggle ? (
          <>
            <a href="#" className="sidebar-logo-link">
              <img src="/assets/images/logo.svg" alt="Logo" className="sidebar-logo-img" />
            </a>
            <button
              onClick={toggle}
              className="sidebar-toggle-inline-btn"
              aria-label="Collapse Sidebar"
            >
              <PanelLeftClose size={18} />
            </button>
          </>
        ) : (
          <button
            onClick={toggle}
            className="sidebar-toggle-inline-btn collapsed"
            aria-label="Expand Sidebar"
          >
            <PanelLeft size={18} />
          </button>
        )}
      </div>

      {/* Scrollable menu */}
      <div className="sidebar-menu-wrapper">
        <nav className="navbox">
          <ul
            className="nav nav-pills nav-sidebar flex-column sidebar-menu-list"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            {SidebarData &&
              SidebarData.map((val, key) => {
                const hasPermission = val.permission ? checkPermission.hasPermission(val.permission, false) : true;
                if (hasPermission) {
                  return (
                    <Menu
                      key={key}
                      data={val}
                      toggle={toggle}
                      setOpen={setOpen}
                      sidebarToggle={sidebarToggle}
                    />
                  );
                }
                return null;
              })}
          </ul>
        </nav>
      </div>

    </aside>
  );
}

export default Sidebar;
